import type { MeResponse } from '@platform/contracts';
import { QueryClient, queryOptions, useSuspenseQuery } from '@tanstack/react-query';

import { ApiError, api } from './api';

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        refetchOnWindowFocus: false,
        // No reintentar errores del cliente (401/403/404/429): no se arreglan solos.
        retry: (count, err) => !(err instanceof ApiError && err.status < 500) && count < 2,
      },
      mutations: { retry: false },
    },
  });
}

export const meQuery = queryOptions({
  queryKey: ['me'],
  queryFn: () => api<MeResponse>('/api/me'),
  staleTime: 60_000,
});

export function useMe(): MeResponse {
  return useSuspenseQuery(meQuery).data;
}
